import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { InputControlBase } from './../forms/input-control.base';

/** @deprecated Use `astral-textarea` in new or Astralized templates. */
@Component({
    selector: 'app-text-area',
    templateUrl: './text-area.component.html',
    styleUrls: ['./text-area.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextAreaComponent extends InputControlBase {
  @Input() rows: number = 5;
  @Input() nameplate: boolean = false;
  @Output() blur: EventEmitter<void> = new EventEmitter<void>();
  constructor() {
    super();
  }

  onKeyDown(event: KeyboardEvent): void {
    if (this.nameplate === false) return;

    const textarea: HTMLTextAreaElement = event.target as HTMLTextAreaElement;
    // Allow Enter only if no newline exists yet
    if (event.key === 'Enter') {
      if ((textarea.value.match(/\n/g) || []).length >= 1) {
        event.preventDefault();
      }
    }

    // Allow only valid characters (customize regex as needed)
    const allowedKeys = /^[a-zA-ZåäöÅÄÖ0-9 &.,!?\-']$/;
    if (
      event.key.length === 1 && // Only check printable characters
      !allowedKeys.test(event.key) &&
      event.key !== 'Enter'
    ) {
      event.preventDefault();
    }
  }

  onInput(event: Event): void {
    if (this.nameplate === false) return;

    const textarea: HTMLTextAreaElement = event.target as HTMLTextAreaElement;
    // Limit to only one newline (in case of paste or typing)
    let parts = textarea.value.split(/\r?\n/);
    if (parts.length > 2) {
      textarea.value = parts.slice(0, 2).join('\n');
    }
    // Also update the form control, not just the textarea DOM value
    this.control.setValue(textarea.value);
  }

  onblur(): void {
    super.onblur();
    if (this.control && !this.control.touched) {
      this.control.markAsTouched();
    }
    this.blur.emit();
  }
}
